import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import details from '@/components/details'
import press from '@/components/press'
import commodity from '@/components/commodity'
import products from '@/components/products'

Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			name: 'HelloWorld',
			meta:{title:'领博生物官网'},
			component: HelloWorld
		},
		{
			path: '/details',
			name: 'details',
			meta:{title:'领博生物官网-新闻详情'},
			component: details
		},
		{
			path: '/press',
			name: 'press',
			meta:{title:'领博生物官网-新闻列表'},
			component: press
		},
		{
			path: '/commodity',
			name: 'commodity',
			meta:{title:'领博生物官网-产品列表'},
			component: commodity
		},
		{
			path: '/products',
			name: 'products',
			meta:{title:'领博生物官网-产品列表'},
			component: products
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js